import styled from 'styled-components'

import { Table } from '../Table/table.styles'

export { TableHeader } from '../Table/table.styles'
export { TableRow } from '../Table/TableRow/tableRow.styles'

export const SideCells = styled(Table)`
    z-index: 100;
    position: sticky;
    left: 0;
    border-spacing: 0 2px;
    background: ${({ theme }) => theme.colors.primaryWhite};
`

export const MetricSelectContainer = styled.th`
    height: 62px;
    background: ${({ theme }) => theme.colors.primaryWhite};
    z-index: 101;
    position: relative;
`

export const EmptyCell = styled.td`
    z-index: 100;
    position: sticky;
    left: 0;
    height: 70px;
    background: ${({ theme }) => theme.colors.primaryWhite};
`

export const SideCell = styled.td`
    padding: 0;
    position: sticky;
    left: -1px;
    z-index: 100;
    max-width: 160px;
    background: ${({ theme }) => theme.colors.primaryWhite};
    cursor: pointer;

    > div::before {
        content: '';
        display: block;
        position: absolute;
        z-index: -1;
        background-color: white;
        border-radius: 0px;
    }
`
